import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './cannot-find-my-product.component.html';
var CannotFindMyProductComponent = (function () {
    function CannotFindMyProductComponent() {
        this.showForm = false;
    }
    CannotFindMyProductComponent.prototype.toggle = function (deviceType) {
        this.showForm = false;
        deviceType.selected = !Boolean(deviceType.selected);
    };
    CannotFindMyProductComponent.prototype.anySelected = function () {
        return (this.deviceTypes || []).some(function (dt) { return dt.selected || false; });
    };
    CannotFindMyProductComponent.prototype.showMore = function () {
        this.showForm = true;
    };
    CannotFindMyProductComponent.prototype.getFormUrl = function () {
        var _a, _b;
        var selectedDeviceTypes = (this.deviceTypes || [])
            .filter(function (dt) { return dt.selected || false; });
        var webFormUrl = '';
        var businessDeviceType = selectedDeviceTypes
            .filter(function (x) { var _a; return ((_a = x.segmentType) === null || _a === void 0 ? void 0 : _a.name) === "Business"; })[0];
        var otherDeviceType = selectedDeviceTypes
            .filter(function (dt) {
            return !dt.segmentType || dt.segmentType.name !== "Business";
        })[0];
        if (businessDeviceType) {
            webFormUrl = ((_a = businessDeviceType.segmentType) === null || _a === void 0 ? void 0 : _a.webFormUrl) || '';
        }
        else if (otherDeviceType) {
            webFormUrl = ((_b = otherDeviceType.segmentType) === null || _b === void 0 ? void 0 : _b.webFormUrl) || '';
        }
        return this.showForm ? webFormUrl : 'about:blank';
    };
    CannotFindMyProductComponent.$inject = [];
    __decorate([
        Input('='),
        __metadata("design:type", Array)
    ], CannotFindMyProductComponent.prototype, "deviceTypes", void 0);
    CannotFindMyProductComponent = __decorate([
        Component({
            selector: 'cannotFindMyProduct',
            template: template,
        })
    ], CannotFindMyProductComponent);
    return CannotFindMyProductComponent;
}());
export { CannotFindMyProductComponent };
